import { Component } from '@angular/core';

@Component({
  selector: 'app-manage-tokens',
  standalone: true,
  imports: [],
  templateUrl: './manage-tokens.component.html',
  styleUrl: './manage-tokens.component.css'
})
export class ManageTokensComponent {

}
